import { useSyncExternalStore } from "react";
import { canv } from "@/canv/global";
import type { VoteWindow } from "../../VoteWindow";
import { NewVoteController } from "../NewVoteController";

function useVotesCount(voteWindow: VoteWindow) {
    return useSyncExternalStore(voteWindow.subscribeVotesCount, voteWindow.getVotesCountSnapshot);
}

export function VotesController() {
    const votesCount = useVotesCount(canv.appInterface.voteWindow);

    const handleChange = (votes: number) => {
        canv.appInterface.voteWindow.setVotesCount(votesCount + votes);
    };

    const handleInputChange = (votes: number) => {
        canv.appInterface.voteWindow.setVotesCount(votes);
    };

    return (
        <NewVoteController
            name="Голоса"
            description="на участника"
            count={votesCount}
            onChange={handleChange}
            onInputChange={handleInputChange}
        />
    );
}
